import { render } from "./teachResearchDetail.vue?vue&type=template&id=58918d85&scoped=true"
import script from "./teachResearchDetail.vue?vue&type=script&lang=js"
export * from "./teachResearchDetail.vue?vue&type=script&lang=js"

import "./teachResearchDetail.vue?vue&type=style&index=0&id=58918d85&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58918d85"]])

export default __exports__